import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ChatStore, for use in the registry */ export const ChatStoreActionTypes = [
    ActionType.AddChatMessageAction,
    ActionType.AddChatMessageFailedAction,
    ActionType.AddChatMessageSucceededAction,
    ActionType.DeleteChatMessageAction,
    ActionType.DeleteChatMessageFailedAction,
    ActionType.DeleteChatMessageSucceededAction,
    ActionType.FetchChatMessagesForTaskAction,
    ActionType.FetchChatMessagesForTaskFailedAction,
    ActionType.FetchChatMessagesForTaskSucceededAction,
    ActionType.UpdateChatMessageAction,
    ActionType.UpdateChatMessageFailedAction,
    ActionType.UpdateChatMessageSucceededAction
];
